import {
  SegmentEditsMap,
  SegmentRow,
  SegmentRowEdit
} from '@blisspointmedia/bpm-types/dist/SegmentationMapping';

export type { SegmentEditsMap, SegmentRow, SegmentRowEdit };

export interface BillingMappingLabelRule {
  id: number;
  company: string;
  name: string;
  rulePriority: number;
  filterState: string;
  filterTokens: string;
  isAdvanced: boolean;
  setBillingSegment: string;
  setBillingSegmentValue: string;
  startDate: string;
  endDate: string | null;
  createdBy: string;
  lastUpdatedBy: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export interface CommittedValue {
  valueId: number;
  valueName: string;
}

export interface NewValue {
  valueId: string;
  valueName: string;
  segmentId: number | string;
}

export interface CustomSegmentsData {
  segmentId: string;
  segmentName: string;
  values: CommittedValue[];
}

export const SystemGeneratedSegmentNames = {
  PLATFORM: 'Platform',
  CHANNEL: 'Channel'
} as const;
export type SystemGeneratedSegmentNameType =
  (typeof SystemGeneratedSegmentNames)[keyof typeof SystemGeneratedSegmentNames];

export const PresetSegmentNames = {
  TACTIC: 'Tactic',
  FUNNEL_TIER: 'Funnel Tier',
  PROMO: 'Promo',
  BUDGET_TYPE: 'Media Budget Type',
  GEO: 'Geo',
  BILLING_CATEGORY: 'Billing Category'
} as const;
export type PresetSegmentNameType = (typeof PresetSegmentNames)[keyof typeof PresetSegmentNames];

export const PRESET_VALUES_MAP: Record<PresetSegmentNameType, string[]> = {
  [PresetSegmentNames.TACTIC]: [
    'ASC+',
    'Auto',
    'Brand',
    'Conquesting',
    'Demand Gen',
    'Direct',
    'Keyword Targeting',
    'Multi',
    'Nonbrand',
    'Product Targeting',
    'Prospecting',
    'Reach',
    'Remarketing',
    'Retargeting',
    'Retention',
    'Test',
    'Traffic'
  ],
  [PresetSegmentNames.FUNNEL_TIER]: ['Upper Funnel', 'Mid Funnel', 'Lower Funnel'],
  [PresetSegmentNames.PROMO]: ['Evergreen', 'Promo'],
  [PresetSegmentNames.BUDGET_TYPE]: ['Performance', 'Co-op', 'Brand', 'DTC'],
  [PresetSegmentNames.GEO]: [],
  [PresetSegmentNames.BILLING_CATEGORY]: []
};

export const TabOptions = {
  LABELED: 'Labeled',
  PARTIALLY_LABELED: 'Partially Labeled',
  UNLABELED: 'Unlabeled'
} as const;
export type TabOptionsType = (typeof TabOptions)[keyof typeof TabOptions];

// last_modified_by value on edits made by the nightly labeling automation.
export const AUTOMATION_USER_EMAIL = 'automation@tinuiti.com';

export const NAMES_IDS_OPTIONS = ['Names', 'IDs'] as const;
export type NamesIdsOptionType = (typeof NAMES_IDS_OPTIONS)[number];

export const TIMESTAMP_EMAIL_OPTIONS = ['Timestamp', 'Email'] as const;
export type TimestampEmailOptionType = (typeof TIMESTAMP_EMAIL_OPTIONS)[number];

export interface EditsMapAction {
  type:
    'UPDATE_SEGMENT_EDIT' | 'DELETE_SEGMENT_EDIT' | 'SET_STATE_FROM_CACHE' | 'SET_MAP' | 'RESET';
  cachedState?: SegmentEditsMap;
  editsMap?: SegmentEditsMap;
  updates?: { rows: SegmentRow[]; edits: SegmentRowEdit }[];
  campaign_keys?: string[];
  segmentNames?: string[];
}
